import { forwardRef } from "react";
import styled from "styled-components";

const SelectInput = styled.select.attrs(({ size }) => ({
  className: "form-control" + (size ? " form-control-sm" : ""),
}))`
  background: rgb(244, 245, 246) !important;
  &:focus {
    box-shadow: 0 0 0 2px #68717840 !important;
  }
  border: none !important;

  ${(props) =>
    props.filter
      ? `
   color: #1F272E;
 `
      : ""}
`;

const Input = styled.input.attrs((props) => ({
  className: `form-control ${props.isInvalid ? "is-invalid" : ""}`,
}))``;

const TextArea = styled.textarea.attrs((props) => ({
  className: "form-control",
}))`
  background: rgb(244, 245, 246) !important;
  &:focus {
    box-shadow: 0 0 0 2px #68717840 !important;
  }
  border: none !important;
`;

// const Group = styled.div.attrs((props) => ({
//   className: `${"form-group" + props.size ? props.size : ""}`,
// }))``;

function Group({ children }) {
  return <div className="form-group">{children}</div>;
}

const InvalidFeedback = styled.div.attrs((props) => ({
  className: "invalid-feedback",
}))``;
// Form.TableCellInput = TableCellInput;
Form.Input = Input;
Form.Group = Group;
Form.TextArea = TextArea;
Form.SelectInput = SelectInput;
Form.InvalidFeedback = InvalidFeedback;

export default function Form({ children, ...props }) {
  return <form {...props}>{children}</form>;
}
